import { defineStore } from "pinia";
import { computed } from "vue";
import { RouteLocationOptions, RouteLocationRaw, useRoute, useRouter } from "vue-router";

export default defineStore("ModalStore", () => {
  const router = useRouter();
  const route = useRoute();

  const modalRoutes = computed(() => {
    const paths = route.hash.trim() !== ""
      ? route.hash
        .replace("#", "")
        .split(",")
        .filter(Boolean)
      : [];

    return paths.filter((path) => !path.startsWith("access_token")).map((path) => router.resolve(path));
  });

  const modalRoutePaths = computed(() => {
    return modalRoutes.value.map((route) => route.path);
  });

  function openModal (to: RouteLocationRaw, options: RouteLocationOptions = {}) {
    const paths = [...modalRoutePaths.value];
    const {
      path,
    } = router.resolve(to);

    if (paths.at(-1) !== path) {
      paths.push(path);
    }

    return updateModalPaths(paths, options);
  }

  function replaceModal (to: RouteLocationRaw, options: RouteLocationOptions = {}) {
    const paths = [...modalRoutePaths.value];
    paths.pop();
    paths.push(router.resolve(to).path);

    return updateModalPaths(paths, {
      replace: true,
      ...options,
    });
  }

  function closeActiveModal () {
    const paths = [...modalRoutePaths.value];
    paths.pop();

    return updateModalPaths(paths);
  }

  function closeAllModals () {
    return updateModalPaths([]);
  }

  function updateModalPaths (paths: Array<string>, options: RouteLocationOptions = {}) {
    const hash = paths.length > 0
      ? "#" + paths.join(",")
      : "";

    return router.push({
      query: route.query,
      hash,
      ...options,
    });
  }

  return {
    openModal,
    replaceModal,
    closeActiveModal,
    closeAllModals,
    modalRoutes,
  };
});
